module.exports = __webpack_public_path__ + "img/img_ccfanghu.8450d024.png";